import { render, staticRenderFns } from "./DrawerChangeCover.vue?vue&type=template&id=1bbb5364&scoped=true&"
import script from "./DrawerChangeCover.vue?vue&type=script&lang=js&"
export * from "./DrawerChangeCover.vue?vue&type=script&lang=js&"
import style0 from "./DrawerChangeCover.vue?vue&type=style&index=0&id=1bbb5364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb5364",
  null
  
)

export default component.exports